import TextMessage from './TextMessage';
import { TextMessageProps, TextMessageValueProps } from './types';

export type { TextMessageProps, TextMessageValueProps };
export default TextMessage;
